import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./AboutUs.css";
import missionLogo from "../../../../assets/images/5star-logo-badge.png";
import { Images } from '../../../../assets/assets';
import { Link } from 'react-router-dom';
import { useAboutUsStore } from "../../../../store/useAboutUsStore";

const MissionSection = () => {
  let { mission } = useAboutUsStore();
  return (
    <section className="mission-section position-relative">
      <Container className="theme-container">
        <Row className="align-items-center">
          <Col lg={6} className="text-center text-lg-start mb-4 mb-lg-0">
            <div className="mission-left-col-content">
              <p className="section-subtitle mb-2">{mission?.subTitle}</p>
              <h3 className="mb-xl-3 mb-2">{mission?.title}</h3>
              <p className="text-light-gray mb-lg-3 mb-2">
                {mission?.description?.split("\n").map((line, idx) => (
                  <span key={idx}>
                    {line} <br />
                  </span>
                ))}
              </p>
              <div className='btn-holder mt-xl-5 mt-lg-4 mt-md-3 mt-2'>
                <Link to="/contact-us" className="btn btn-solid-black">
                  <span className="fw-bold me-3 ">{mission?.buttonText}</span>
                  <img className="img-fluid" src={Images.FancyWhiteCornerIcon} alt="Phone icon" />
                </Link>
              </div>
            </div>
          </Col>
          <Col lg={6} className="text-center">
            <div className="mission-right-col">
              <img src={mission?.images} alt="5 Star Grading Logo" className="img-fluid mission-logo" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MissionSection;
